module.exports = __webpack_public_path__ + "media/dorobek/assets/images/i-ce107393e99d19a089474e29755719ed.svg";